module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-3"
  }, [(_vm.value) ? _c('v-img', {
    attrs: {
      "aspect-ratio": 16 / 9,
      "height": "150",
      "src": _vm.imgUrl
    }
  }, [_c('v-card-title', {
    on: {
      "click": function($event) {
        _vm.showdialog = true
      }
    }
  }, [_c('v-btn', [_vm._v("Change")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('help-popover', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("\n        We'll use this image on your website and in general when we want to make your appointment types look nice\n      ")])], 1)], 1) : _c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-btn', {
    attrs: {
      "absolute": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = true
      }
    }
  }, [_vm._v("Choose one")]), _vm._v("\n    No background image"), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "max-width": "80%"
    }
  }, [_vm._v("\n      We'll use this image on your website and in general when we want to make your appointment types look nice\n    ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.showdialog),
      callback: function($$v) {
        _vm.showdialog = $$v
      },
      expression: "showdialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Choose a background picture")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showdialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('image-search', {
    attrs: {
      "title": "Search for an image"
    },
    on: {
      "close": function($event) {
        _vm.showdialog = false
      }
    },
    model: {
      value: (_vm.imgUrl),
      callback: function($$v) {
        _vm.imgUrl = $$v
      },
      expression: "imgUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessages && _vm.errorMessages.length > 0) ? _c('v-alert', {
    staticClass: "pt-0 pb-1",
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_c('ul', _vm._l((_vm.errorMessages), function(err) {
    return _c('li', {
      key: err,
      domProps: {
        "textContent": _vm._s(err)
      }
    })
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b73b699","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BackgroundSelector.vue
// module id = 1367
// module chunks = 9